import { CreatableReportTemplate } from "@nova/schemas"
import {
    useGenerateReportFromCreatableTemplate,
    useReportTemplates,
} from "features/pilot-tracking/report-templates/ReportTemplateQueries"
import { ReportTemplateForm } from "features/pilot-tracking/report-templates/ReportTemplateForm"
import { useRouter } from "pages"
import { getGenericWorkspacePage, getGenericWorkspacePageHeader } from "../WorkspaceRoutes"

export const GenerateReportPage = getGenericWorkspacePage({
    Header: getGenericWorkspacePageHeader({
        title: "Generate Report",
    }),
    Content: GenerateReportPageContent,
    maxWidth: 1200,
})

function GenerateReportPageContent() {
    const router = useRouter("/workspace/:workspaceId")
    const { generateReport } = useGenerateReportFromCreatableTemplate()
    const { data: reportTemplates } = useReportTemplates()

    if (!reportTemplates) return null

    const handleSubmit = async (template: CreatableReportTemplate) => {
        await generateReport({ template })
    }
    const timestamp = new Date().toLocaleDateString()

    return (
        <div className="w-full flex justify-center h-full overflow-hidden pb-4">
            <ReportTemplateForm
                initialValues={{ name: `Report - ${timestamp}` }}
                onCancel={() => router.navigate({ path: "/fleet/reports" })}
                onSubmit={handleSubmit}
                afterSubmit={() => router.navigate({ path: "/fleet/reports" })}
                operation="generate"
            />
        </div>
    )
}
